/* eslint-disable */
require('./social-apple')
require('./social-facebook')
require('./social-google')
require('./social-telegram')
require('./eye')
require('./eye-close')
require('./envelope')
require('./arrow-left')
